import axios from 'axios';
import { buildApiUrl } from './apiConfig';

export const getToolsList = async (filters = {}) => {
  try {
    // const params = new URLSearchParams();
    // if (filters.type) params.append('type', filters.type);
    // if (filters.name) params.append('name', filters.name);
    // if (filters.tags) params.append('tags', filters.tags);
    // if (filters.category) params.append('category', filters.category);
    // 
    // const response = await axios.get(
    //   buildApiUrl(`/v1/tools/list?${params.toString()}`)
    // );
    // return response;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: [
              {
                tool_id: "send-email",
                name: "Send email",
                description: "Send emails to communicate information or interact with other people.",
                type: "action",
                category: "conversations",
                required_parameters: []
              },
              {
                tool_id: "human-in-the-loop-alert",
                name: "Human in the loop Alert",
                description: "Sends notifications or alerts to involve a human operator when manual intervention is required, ensuring informed decisions in critical situations.",
                type: "action",
                category: "support",
                required_parameters: []
              },
              {
                tool_id: "follow-up",
                name: "Follow Up",
                description: "Proactively follows up on previous actions to ensure compliance, gather feedback, and provide relevant updates.",
                type: "action",
                category: "support",
                required_parameters: []
              },
              {
                tool_id: "web-search",
                name: "Web Search",
                description: "Use this function to perform a web search given a specific query. This function is triggered when a customer inquires about information that requires searching the web.",
                type: "action",
                category: "research",
                required_parameters: []
              },
              {
                tool_id: "schedule-appointment",
                name: "Schedule appointment",
                description: "Coordinates and organizes appointments based on user availability and specific requirements, ensuring efficient time management.",
                type: "action",
                category: "scheduling",
                required_parameters: []
              },
              {
                tool_id: "repair-schedule",
                name: "Repair Schedule",
                description: "Facilitates the scheduling of repairs, managing requests and assigning available technicians according to service priority.",
                type: "action",
                category: "service",
                required_parameters: []
              }
            ],
            msgCode: "success"
          },
          status: 200
        });
      }, 500);
    });
  } catch (error) {
    console.error('Error fetching tools list:', error);
    throw error;
  }
};

export const getActionsList = async (filters = {}) => {
  try {
    // const params = new URLSearchParams();
    // if (filters.type) params.append('type', filters.type);
    // if (filters.name) params.append('name', filters.name);
    // if (filters.category) params.append('category', filters.category);
    // 
    // const response = await axios.get(
    //   buildApiUrl(`/v1/action/list?${params.toString()}`)
    // );
    // return response;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: [
              {
                action_uuid: "send-email",
                name: "Send email",
                description: "Send emails to communicate information or interact with other people.",
                type: "action",
                categories: "conversations",
                icon: ""
              },
              {
                action_uuid: "human-in-the-loop-alert",
                name: "Human in the loop Alert",
                description: "Sends notifications or alerts to involve a human operator when manual intervention is required, ensuring informed decisions in critical situations.",
                type: "action",
                categories: "support",
                icon: ""
              },
              {
                action_uuid: "follow-up",
                name: "Follow Up",
                description: "Proactively follows up on previous actions to ensure compliance, gather feedback, and provide relevant updates.",
                type: "action",
                categories: "support",
                icon: ""
              },
              {
                action_uuid: "web-search",
                name: "Web Search",
                description: "Use this function to perform a web search given a specific query. This function is triggered when a customer inquires about information that requires searching the web.",
                type: "action",
                categories: "research",
                icon: ""
              },
              {
                action_uuid: "schedule-appointment",
                name: "Schedule appointment",
                description: "Coordinates and organizes appointments based on user availability and specific requirements, ensuring efficient time management.",
                type: "action",
                categories: "scheduling",
                icon: ""
              },
              {
                action_uuid: "repair-schedule",
                name: "Repair Schedule",
                description: "Facilitates the scheduling of repairs, managing requests and assigning available technicians according to service priority.",
                type: "action",
                categories: "service",
                icon: ""
              }
            ],
            msgCode: "success"
          },
          status: 200
        });
      }, 500);
    });
  } catch (error) {
    console.error('Error fetching actions list:', error);
    throw error;
  }
};

export const getAgentTools = async (agentUuid) => {
  try {
    // const response = await axios.get(
    //   buildApiUrl(`/v1/agents/${encodeURIComponent(agentUuid)}/tools`)
    // );
    // return response;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: [],
            msgCode: "success"
          },
          status: 200
        });
      }, 500);
    });
  } catch (error) {
    console.error(`Error fetching agent tools with uuid ${agentUuid}:`, error);
    throw error;
  }
};

export const updateAgentTools = async (agentUuid, body) => {
  try {
    // const response = await axios.put(
    //   buildApiUrl(`/v1/agents/${encodeURIComponent(agentUuid)}/tools`),
    //   body
    // );
    // return response;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: body.tools,
            msgCode: "success",
            message: "Tools updated successfully"
          },
          status: 200
        });
      }, 800);
    });
  } catch (error) {
    console.error(`Error updating agent tools with uuid ${agentUuid}:`, error);
    throw error;
  }
};

export const addToolToAgent = async (agentUuid, tool) => {
  try {
    // const response = await axios.post(
    //   buildApiUrl(`/v1/agents/${encodeURIComponent(agentUuid)}/tools`),
    //   tool
    // );
    // return response;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: tool,
            msgCode: "success",
            message: "Tool added successfully"
          },
          status: 200
        });
      }, 600);
    });
  } catch (error) {
    console.error(`Error adding tool to agent ${agentUuid}:`, error);
    throw error;
  }
};

export const removeToolFromAgent = async (agentUuid, toolId) => {
  try {
    // const response = await axios.delete(
    //   buildApiUrl(`/v1/agents/${encodeURIComponent(agentUuid)}/tools/${encodeURIComponent(toolId)}`)
    // );
    // return response;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            msgCode: "success",
            message: "Tool removed successfully"
          },
          status: 200
        });
      }, 500);
    });
  } catch (error) {
    console.error(`Error removing tool ${toolId} from agent ${agentUuid}:`, error);
    throw error;
  }
};

